<template>
  <img
    v-if="src && !broken"
    :src="src"
    :alt="alt"
    @error="broken = true"
  >
  <span
    v-else
    class="company-logo__stub"
  >
    <i class="exu-building-05" />
  </span>
</template>

<script>
export default {
  name: 'CompanyLogo',
  props: {
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // Логотип может не загрузиться и при непустой ссылке: в павильоне связь
      // рвётся, а на стенде бэкенда файл бывает битым. Пустая ссылка и
      // сорвавшаяся загрузка для посетителя — одно и то же, поэтому заглушка
      // общая.
      broken: false,
    };
  },
  watch: {
    // Карточки в списке переиспользуются: Vue отдаёт тот же экземпляр под
    // другую компанию. Без сброса заглушка от предыдущей осталась бы на
    // месте живого логотипа.
    src() {
      this.broken = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

// Размер задан числом, а не резиновый: контейнер логотипа в карточке сам
// подстраивается под содержимое, и от `width: 100%` плитка схлопывалась в
// узкую полосу. Квадрат в 88px повторяет то место, которое занимает обычный
// логотип, а `max-width` оставляет её целой в тесных местах вроде профиля.
.company-logo__stub {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  max-width: 100%;
  background: $color-base-secondary;
  border-radius: $border-radius-inside;
  color: $color-disabled;

  & > i {
    font-size: 32px;
    line-height: 1;
  }
}
</style>
